import React from 'react';
import './CreatePasswordComponent.less';
import {ButtonPrimary, ButtonLink} from '@homeaway/react-buttons';
import {apiPost} from '../../util/api.client';
import {getSiteHeader} from '../../util/siteHeaderUtils';

const API_URL = '/auth/aam/v3/password/reset';

function CreatePasswordComponent({displayButton, emailAddress, handleError, lingua, service, updatePage, site}) {
    function returnToResetPassword() {
        const body = {
            emailAddress,
            serviceUrl: service
        };

        apiPost(API_URL, body, getSiteHeader(site)).then(({status}) => {
            if (status === 204) {
                updatePage('passwordreset');
            } else {
                handleError(lingua.read('error.generic'), '');
            }
        });
    }
    return (
        <div className="text-center">
            {displayButton === true &&
                <ButtonPrimary className="Create-password-btn" label={lingua.read('lex.password.create.mu')} onClick={returnToResetPassword}/>
            }
            {displayButton !== true &&
                <ButtonLink className="Link" label={lingua.read('lex.password.create.option')} onClick={returnToResetPassword}/>
            }
        </div>
    );
}

export default CreatePasswordComponent;
